import React from 'react';
import styled from 'styled-components';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.instance = props.instance;
  }

  render() {
    return(
      <Component>
        <ul>
          <li>Uwazi</li>
          <li>{this.instance}</li>
          <li>Libreria</li>
          <li>Login</li>
        </ul>
      </Component>
    )
  }
}

const Component = styled.footer`
  border-top: 1px solid #ccc;
  height: 50px;
  text-align: center;

  ul {
    padding: 0;
    list-style-type: none;
  }

  li {
    color: #777;
    display: inline-block;
    padding: 0 15px;
  }
`

export default Footer;



// WEBPACK FOOTER //
// ./src/UI/Footer/Footer.js